module.exports = __webpack_public_path__ + "static/img/envelope.645fe4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/envelope.svg
// module id = fVWz
// module chunks = 6